import { render, staticRenderFns } from "./DonutChart31.vue?vue&type=template&id=77995f16&scoped=true&"
import script from "./DonutChart31.vue?vue&type=script&lang=js&"
export * from "./DonutChart31.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77995f16",
  null
  
)

export default component.exports